import { isCartOpen } from '@stores/cartStore'
import 'balloon-css'

const StickyAddToCart = ({ handleAddToCart, showStickyATC, currentSize }) => {
    let $isCartOpen = isCartOpen.get()

    return (
        <div
            className={`sticky-atc-outer bottom-0 w-full bg-oat/90 p-6 z-[999] ${
                showStickyATC ? 'fixed' : 'hidden'
            } md:hidden ${$isCartOpen ? 'hidden' : ''}`}
        >
            {!currentSize.size ? (
                <p className="block mobile-size-error text-xs mb-0 font-normal w-full md:hidden left-0 top-0">
                    Please select a size
                </p>
            ) : null}
            <div className="sticky-atc-inner flex items-center justify-center relative">
                <button
                    type={!currentSize.size ? null : 'submit'}
                    id="pdp-sticky-add-to-cart"
                    className={`large-button button-atc w-full !h-12 flex-grow mb-2 ${
                        !currentSize.size
                            ? 'disabled noclick !opacity-50 cursor-not-allowed'
                            : 'hover:bg-ash opacity-100'
                    }`}
                    // data-balloon-blunt
                    data-balloon-pos="up"
                    aria-label={
                        !currentSize.size ? 'Please select a size' : null
                    }
                    onClick={(e) => handleAddToCart(e)}
                >
                    Add To Cart
                </button>
            </div>
        </div>
    )
}

export default StickyAddToCart
